<script>
	import { onMount, afterUpdate} from 'svelte';
	import { scaleOrdinal } from 'd3-scale';

	import * as d3 from 'd3';




	//Maps
	import MapUSA from './charts/map-usa.svelte'

	//Graphic Components
	import GraphicTitle from './components/GraphicTitle.svelte'
	import GraphicFooter from './components/GraphicFooter.svelte'

	//Helpers
	import * as colors from './helpers/colors.js'
	import { pastels } from './helpers/colors.js'

	import statehex from "./helpers/USStateHexbin.js";

	// import { pastels } from '../helpers/colors.js'


	//Dataset
	// import * as turnout from '../public/datasets/turnout.json'
	// import * as applemaps from '../public/datasets/applemaps.json'
	// // import * as bannedLearning from '../public/datasets/bannedLearning.json'
	// import * as waffledata from '../public/datasets/waffledata.json'
	// import * as testData from '../public/datasets/test.json'
	import * as test from '../public/datasets/test.json'

	import * as bannedLearning from '../public/datasets/banned-learning.json'
	import * as bannedLearningRedo from '../public/datasets/banned-learning-redo.json'


	let dataset;
	let selectoptions;
	let active;
	let colour;
	// let schemes = [colors.divergingbrownteal, colors.political, colors.dark]

	onMount(function() {
		selectoptions = ([...new Set(bannedLearning.default.map(
			function(d){
				// if(d.status !== "None"){
					console.log(d.state)
				return d.state;
			 // }
			}



		))])

		active = selectoptions[0]
		// dataset = bannedLearningRedo.default.filter(d => (d.state === active))
		dataset = bannedLearningRedo.default.filter(function(d){

			return d.state === active;
		})
		// colorScale.domain(bannedLearning.default.map(d => d.state))
		// console.log(dataset)

	})

	afterUpdate(function() {

		dataset = bannedLearningRedo.default.filter(function(d){
			// console.log(d)
			// // if(d.status === "Signed" || d.status === "Proposed" || d.status === "Vetoed" || d.books_banned !== "N/A"){

			return d.state === active;
			// }
		})
	})


	export let width = Math.min(

		document.getElementById('svelte-app').getBoundingClientRect().width,
		900
	);

	// console.log(bannedLearning.default[0]);
	function getorientation(w) {
		if (w > 750) {
			return "vertical"
		} else {
			return "horizontal"
		}
	}

	export let height = 400;

function chartHeight(x){
	if(window.innerWidth <= 400){

		return x/2;

	}
	else if(window.innerWidth <= 820){

			return x/1.25;

		}
	else{

		return x;
	}
}

	function handleMouseOver(e) {
	colour = 'green';
}
function handleMouseOut(e) {
	colour = 'red';
}

const main = document.querySelector('chart-container');
const toTopButton = document.querySelector('btt-button');

function obCallback(payload) {
  if (payload[0].isIntersecting === true) {
    toTopButton.classList.add('is-visible');
  } else {
    toTopButton.classList.remove('is-visible');
  }
}

if(main && toTopButton) {
  const ob = new IntersectionObserver(obCallback, {
    threshold: 0.2
  });
  ob.observe(main);
}

// window.onscroll = function (oEvent) {
//   var mydivpos = document.getElementsByTagName("btt-button").offsetTop;
//   var scrollPos = document.querySelector('body').scrollTop;
//
//   if(scrollPos >= toTopButton){
// 	  document.getElementsByTagName("btt-button").className = "";
// 	  toTopButton.style.display = "flex";
//
//   }
//
//   else{
// 	  document.getElementsByTagName("btt-button").className = "hidden";
//  toTopButton.style.display = "none";
//   }
// };
// var dateSpan = document.createElement('span')
// dateSpan.innerHTML = dateString;
// var li = document.createElement('li');
// li.appendChild(dateSpan);

</script>

<style>

.total-wrapper{
	font-family: "akkurat", -apple-system, sans-serif;
	display: flex;

}

.map-wrapper{
	width: 55%;
	display: flex;
	flex-flow: column;
	align-items: center;
justify-content: start;
}

.content-wrapper{
	/* width: 45%; */
	display: flex;
	align-items: center;
	justify-content: start;
	flex-flow: column;
	max-width: 800px;
}

.chart-container{
	position: sticky;
/* bottom: 0; */
}

.content-title{
	text-align: center;
	font-weight: 600;
	font-size: 2rem;
	border-bottom: 2px solid gray;

}

.laws-container{
	padding: 10px 20px;

	/* max-width: 780px; */
}
.bills-wrapper{
	display: flex;
	align-items: flex-start;
	max-width: 800px;
	margin: 20px;
		border-bottom: 2px dashed gray;
		padding: 20px 0;

	flex-flow: column;

}

.bills-container{
	margin: 0 0 20px;
}

.laws-title{
	display: flex;
	align-items: center;
	justify-content: center;
	flex-flow: column;
	font-weight: 600;
	font-size: 1.65rem;
	color: #07406A;
}

#signed-title{
	color: #07406A;
}

#introduced-title{

	color: #A0620B
}

#vetoed-title{
	color: #D03B3B;

}



.info-wrapper{
	width: 150px;
	margin: 10px;
}

#details-container{
	/* width: 550px;
	margin: 10px; */
	font-size: 19px;
}

.bills-title{
	font-size: 22px;
font-weight: 600;
margin: 5px 0;
}

#bills-content{
	font-size: 16px;
}

#date-content{
	font-size: 16px;
	text-decoration: underline;
	/* border-bottom: 1px solid gray; */

}

.book-title{
	text-align: center;
	font-weight: 600;
	padding: 20px;

	font-size: 2rem;
	/* width: 70vw; */

	/* font-size: */
}

.book-container{
	display: flex;
	/* flex-flow: wrap; */
align-content: center;
justify-content: center;

}

a.book-link{
	box-shadow: none !important;
}

img.book-image{
	max-width: 150px;
	max-height: 200px;
	/* height: 35%; */
	margin: 10px;
	border: 1px solid #708090;
}



.dropdown-wrapper{

	display: flex;
    align-items: center;
    justify-content: center;


	/* display: flex; */
	font-weight: 600;
padding: 10px 50px;
	background-color: #d8cfc4;

 border-radius: 5px;
 font-family: "akkurat", -apple-system, sans-serif;

 /* position: sticky;
bottom: 0; */

}

.dropdown-container{
	padding: 20px;
	/* position: -webkit-sticky; */
	position: fixed;
/* bottom: 20px; */
/* top:0; */
}

.dropdown-text{
	margin: 0 10px;
	font-weight: 600;
}

.legend-wrapper{

	    display: flex;
	    align-items: center;
	    justify-content: center;
	    margin: 0 0 20px;
	    flex-flow: wrap;
}

.legend-container{
	display: flex;
	/* margin: 5px; */
	/* width: 400px; */
}

.legend-text{
	font-size: 14px;
	font-weight: 500;
	margin: 0 10px;
	width: 170px;

}

.legend-icon{
	height: 20px;
	  width: 20px;
	  background-color: #bbb;
	  border-radius: 50%;
	  display: inline-block;
     border: solid 1px #333333;
     /* border-right: solid 2px #333333; */
}


/* .legend-icon:before,
.legend-icon:after {
  content: "";
  position: absolute;
  z-index: 1;
  width: 21.21px;
  height: 21.21px;
  -webkit-transform: scaleY(0.5774) rotate(-45deg);
  -ms-transform: scaleY(0.5774) rotate(-45deg);
  transform: scaleY(0.5774) rotate(-45deg);
  background-color: inherit;
  left: 2.3934px;
}

.legend-icon:before {
  top: -10.6066px;
  border-top: solid 2.8284px #333333;
  border-right: solid 2.8284px #333333;
}

.legend-icon:after {
  bottom: -10.6066px;
  border-bottom: solid 2.8284px #333333;
  border-left: solid 2.8284px #333333;
} */

.legend-container:nth-child(1) > .legend-icon{
	background: #F5ECEC;

}

.legend-container:nth-child(2) > .legend-icon{
	background-color: #83afda;

}

.legend-container:nth-child(3) > .legend-icon{
	background-color: #e99f28;

}

.legend-container:nth-child(4) > .legend-icon{
	background-color: #e27a7a;

}

.btt-button {
	position: sticky;
    /* right: 1rem;
    bottom: 3rem; */
    z-index: 20;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background-color: orange;
    justify-content: center;
    align-items: center;

	display: none;

	/* &.is-visible {
   bottom: 1rem;
 } */

}

.hightlight-signed{
	font-weight: 600;
	/* background-color: lightblue; */
	/* margin:10px;  */
	color: #07406A;
	/* text-decoration: underline solid 2px #07406A; */
	font-style: italic;

}

.hightlight-introduced{
	font-weight: 600;
	/* background-color: lightblue; */
	/* margin:10px;  */
	color: #A0620B;
	/* text-decoration: underline solid 2px #A0620B; */
	font-style: italic;

}
.hightlight-vetoed{
	font-weight: 600;
	/* background-color: lightblue; */
	/* margin:10px;  */
	color: #d51e2d;
	/* text-decoration: underline solid 2px #d51e2d; */
	font-style: italic;

}

@media only screen and (max-width: 900px) {

	.total-wrapper{
		flex-flow: column;
		align-items: center;
		justify-content: center;
		/* overflow: auto; */


	}

	.dropdown-wrapper{

			position: fixed;
		    bottom: 0;
		    left: 0;
		    right: 0;
			z-index: 1;
	}

	.map-wrapper{
		width: 100%;
	}

	.content-wrapper{
		width: 100%;
	}

	.chart-container{
		position: relative;
	}

	.content-title{
		margin: 20px;
	}

	.book-container{
		flex-flow: wrap;
	}

	.bills-wrapper{
		/* max-width: 400px; */
		/* flex-flow: column; */
	}

	.dropdown-wrapper{

	/* align-self: flex-start;
	overflow-y: auto; */

	}

	.legend-container{
		width: 50%;
		align-items: center;
		justify-content: center;
		margin: 5px 0;
	}

	.legend-text{
		font-size: 12px;
		width: 250px;

	}

	#details-container{
		font-size: 16px;
	}

	.laws-container{
		margin: 10px;
		width: 100%;
		padding: 0;
		/* width: 100%; */
	}

	.btt-button {
		display: flex;
	}


}

@media only screen and (max-width: 600px) {

	.total-wrapper{
		padding-bottom: 40px;

	}
	.legend-container{
		width: 100%;
		align-items: center;
		justify-content: center;
	}

	.dropdown-wrapper{
		flex-flow: wrap;
		align-items: center;
		justify-content: center;

	}
}

/* .content-title{

} */
/* :global(.legendContainer) {
	font-family:"akkurat", sans-serif
}
:global(div.tooltip) {
	background-color:rgba(0,0,0,0.7);
	display:inline-block;
	padding:8px;
	border-radius:3px;
	color: #fff;
	text-align:center;
	position:absolute;
	visibility:hidden;
	width:200px;
	height:60px;
}

:global(div.tooltip .line1) {
	display:block;
	font-weight:bold;
	font-size:1.1rem;
	margin:0;
}

:global(div.tooltip .line2) {
	display:block;
	font-size:0.9rem;
	line-height: 1.1;
	margin:0;
}

.chart :global(circle)  {
	fill: #d51e2d;
}

:global(svg g text.label) {
	text-transform: uppercase;
	fill: #666;
	font-size:11px;
} */

</style>
<main>

<!-- <GraphicTitle
	title={"Rise in Banned Learning"}
/> -->


<div class = "total-wrapper">
{#if dataset && dataset.length > 0}


	<div class = "map-wrapper">

		<div class = "dropdown-wrapper">
		<!-- <div class = "dropdown-text">Key Orders In </div> -->
			<form>
				<select bind:value={active}>
				<!-- {console.log(active)} -->
					{#each selectoptions as opt}
						<option value={opt}>
							{opt}
						</option>
					{/each}
				</select>
			</form>
		</div>

		<div class = "chart-container" id="map">
			{#each dataset.filter(d => (d.state === active)) as state, i}
					<!-- <div>Active location: {active}</div> -->
					<!-- bind:activeLocation={if(dataset[0].bills_signed !== "N/A"){
							return active;
						}
					else{
							return null;
						}} -->
				<!-- {console.log(dataset[0])}  -->

				<MapUSA
						bind:activeLocation={active}
					data={dataset.filter(d => {
						return d["state"]
					})}
					data2={bannedLearningRedo.default}
					width = {width}
					height = {chartHeight(650)}
					variable={"combined"}
					maptype={"hex"}
				/>


			{/each}

		</div>

		<div class = "legend-wrapper">
			<div class = "legend-container">
				<div class = "legend-icon"></div>
				<div class = "legend-text">No state-level action or bill introduced</div>
			</div>
			<div class = "legend-container">
				<div class = "legend-icon"></div>
				<div class = "legend-text">Bill was signed into law or similar state level action</div>
			</div>
			<div class = "legend-container">
				<div class = "legend-icon"></div>
				<div class = "legend-text">Bill has been proposed</div>
			</div>
			<div class = "legend-container">
				<div class = "legend-icon"></div>
				<div class = "legend-text">Bill has been vetoed, overturned, or stalled</div>
			</div>
		</div>





	</div>




	<div class = "content-wrapper">

		<div class = "content-title">Laws in {dataset[0].state}</div>

		{#if dataset[0].bills_signed !== "N/A"}

		<div class = "laws-container" id = "signed-laws">

			<div class = "laws-title" id = "signed-title">Bills Signed into Law</div>

			<div class = "bills-wrapper">

				<!-- <div class = "info-wrapper">

					<div class = "bills-container" id = "date-container">
						<div class = "bills-title" id = "date-bills">Date</div>
						<div class = "bills-content" id = "date-content">{dataset[0].date_signed}</div>
					</div>

					<div class = "bills-container" id = "name-container">
						<div class = "bills-title" id = "name-bills">Bills</div>

						<div class = "bills-content" id = "bills-content">{dataset[0].bills_signed}</div>

					</div>
				</div> -->




				<div class = "bills-container" id = "details-container">
					<!-- <div class = "bills-title" id = "details-bills">Details</div> -->
					<div class = "bills-content" id = "details-content">{dataset[0].details_signed[0]} <strong class = "hightlight-signed">{dataset[0].details_signed[1]}</strong> {dataset[0].details_signed[2]} <strong class = "hightlight-signed">{dataset[0].details_signed[3]}</strong></div>
				</div>

				<div class = "bills-container" id = "date-container">
				<div class = "bills-title" id = "name-bills">Bills</div>
					<a href = {"" + dataset[0].Link} target="_blank"><div class = "bills-content" id = "date-content">{dataset[0].bills_signed}</div></a>
				</div>

			</div>

		</div>

		{:else}
			<div class = "laws-container" id = "signed-laws"></div>

		{/if}

		{#if dataset[0].bills_introduced !== "N/A"}

			<div class = "laws-container" id = "introduced-laws">
				<div class = "laws-title" id = "introduced-title">Bills Introduced</div>

					<div class = "bills-wrapper">

					<!-- <div class = "info-wrapper">
						<div class = "bills-container" id = "date-container">
							<div class = "bills-title" id = "date-bills">Date</div>
							<div class = "bills-content" id = "date-content">{dataset[0].date_introduced}</div>

						</div>

						<div class = "bills-container" id = "name-container">
							<div class = "bills-title" id = "name-bills">Bills</div>
							<div class = "bills-content" id = "bills-content">{dataset[0].bills_introduced}</div>
						</div>
					</div> -->

						<div class = "bills-container" id = "details-container">
							<!-- <div class = "bills-title" id = "details-bills">Details</div> -->
							<div class = "bills-content" id = "details-content">{dataset[0].details_introduced[0]} <strong class = "hightlight-introduced">{dataset[0].details_introduced[1]}</strong> {dataset[0].details_introduced[2]} <strong class = "hightlight-introduced">{dataset[0].details_introduced[3]}</strong></div>
						</div>

						<div class = "bills-container" id = "date-container">
						<div class = "bills-title" id = "name-bills">Bills</div>
							<a href = {"" + dataset[0].Link} target="_blank"><div class = "bills-content" id = "date-content">{dataset[0].bills_introduced}</div></a>

						</div>

					</div>
		</div>
		{/if}

		{#if dataset[0].bills_vetoed !== "N/A" }

			<div class = "laws-container" id = "vetoed-laws">
				<div class = "laws-title" id = "vetoed-title">Bills Vetoed</div>

				<div class = "bills-wrapper">
					<!-- <div class = "info-wrapper">

						<div class = "bills-container" id = "date-container">
							<div class = "bills-title" id = "date-bills">Date</div>
							<div class = "bills-content" id = "date-content">{dataset[0].date_vetoed}</div>
						</div>

						<div class = "bills-container" id = "name-container">
							<div class = "bills-title" id = "name-bills">Bills</div>
							<div class = "bills-content" id = "bills-content">{dataset[0].bills_vetoed}</div>
						</div>
					</div> -->
					<div class = "bills-container" id = "details-container">
						<!-- <div class = "bills-title" id = "details-bills">Details</div> -->
						<div class = "bills-content" id = "details-content">{dataset[0].details_vetoed[0]} <strong class = "hightlight-vetoed">{dataset[0].details_vetoed[1]}</strong> {dataset[0].details_vetoed[2]} <strong class = "hightlight-vetoed">{dataset[0].details_vetoed[3]}</strong></div>

					</div>

					<div class = "bills-container" id = "date-container">
					<div class = "bills-title" id = "name-bills">Bills</div>

						<a href = {"" + dataset[0].Link} target="_blank"><div class = "bills-content" id = "date-content">{dataset[0].bills_vetoed}</div></a>
					</div>

				</div>

			</div>

		{/if}
		<div class = "content-title">Some Targeted Reading in {dataset[0].state}</div>

		<div class = "book-wrapper">
			<!-- {#each dataset[0].goodreads_link as goodreads_link, i} -->
				<div class = "book-container">
				<!--  -->
					{#each dataset[0].books_banned as books_banned, i}
						{#if dataset[0].books_banned !== "N/A" }
						<!-- {console.log(dataset[0].books_banned)} -->
						<!-- {console.log(dataset[0].goodreads_link[i])} -->

						<a href = {"https://www.goodreads.com/book/show/" +dataset[0].goodreads_link[i]} target="_blank" class = "book-link"><img src={"http://news.northeastern.edu/wp-content/uploads/banned-learning/images/" + dataset[0].books_banned[i] + ".png"} alt={dataset[0].books_title[i] + " by " + dataset[0].books_author[i]} class = "book-image"></a>
							<!-- <a href = "https://www.goodreads.com"><img src={"http://news.northeastern.edu/wp-content/uploads/banned-learning/images/" + books_banned + ".png"} alt="book-image" class = "book-image"></a> -->

							<!-- <a href = "https://www.goodreads.com"><img src={"http://news.northeastern.edu/wp-content/uploads/banned-learning/images/" + books_banned + ".png"} alt="book-image" class = "book-image"></a> -->

							{/if}

							{#if dataset[0].books_banned === "" }
							<!-- {console.log(dataset[0].books_banned)} -->
							<!-- {console.log(dataset[0].goodreads_link[i])} -->

							<a href = {"https://www.goodreads.com/book/show/" +dataset[0].goodreads_link[i]} target="_blank" style="display:none" class = "book-link"><img src={"http://news.northeastern.edu/wp-content/uploads/banned-learning/images/" + dataset[0].books_banned[i] + ".png"} alt={dataset[0].books_title[i] + " by " + dataset[0].books_author[i]} class = "book-image"></a>
								<!-- <a href = "https://www.goodreads.com"><img src={"http://news.northeastern.edu/wp-content/uploads/banned-learning/images/" + books_banned + ".png"} alt="book-image" class = "book-image"></a> -->

								<!-- <a href = "https://www.goodreads.com"><img src={"http://news.northeastern.edu/wp-content/uploads/banned-learning/images/" + books_banned + ".png"} alt="book-image" class = "book-image"></a> -->

								{/if}

					{/each}
					<!--  -->
				</div>
				<!-- {/each} -->
		</div>

		<a href="#map" class="btt-button" aria-label="Nach oben scrollen">
		  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" aria-hidden="true" focusable="false">
			<path d="M0 0h24v24H0V0z" fill="none" />
			<path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" />
		  </svg>
		</a>

	</div>


{/if}



</div>

</main>
